import React, { useState } from "react";
import { Button, CircularProgress, Alert, Stack } from "@mui/material";
import APIURL from "../api/apiClient";


const CleanupImagesButton = () => {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const handleCleanup = async () => {
    if (!window.confirm("Are you sure you want to delete expired images?")) return;

    setLoading(true);
    setResult(null);

    try {
      // ✅ Using your ApiClient class
      const data = await APIURL.get("/cleanupimages.php");

      setResult({
        status: data.status || "success",
        message: data.message || "Cleanup completed successfully.",
        deleted_files: data.deleted_files || [],
        deleted_records: data.deleted_records || [],
      });
    } catch (error) {
      console.error("Cleanup error:", error);
      setResult({
        status: "error",
        message: error.message || "An unexpected error occurred during cleanup.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Stack spacing={2}>
      <Button
        variant="contained"
        color="error"
        onClick={handleCleanup}
        disabled={loading}
      >
        {loading ? <CircularProgress size={24} color="inherit" /> : "Clean Up Images"}
      </Button>

      {result && (
        <Alert severity={result.status === "success" ? "success" : "error"}>
          <div>{result.message}</div>
          {result.deleted_files?.length > 0 && (
            <div>Deleted files: {result.deleted_files.join(", ")}</div>
          )}
          {result.deleted_records?.length > 0 && (
            <div>Deleted records IDs: {result.deleted_records.join(", ")}</div>
          )}
        </Alert>
      )}
    </Stack>
  );
};

export default CleanupImagesButton;
